export default "__VITE_ASSET__e4267762__"